import {
  REQUEST_DEVICES,
  RECEIVE_DEVICES,
  DEVICES_FAILED,
  API_CALL
} from './types';

export const getDeviceTypes = () => ({
  type: API_CALL,
  onRequest: REQUEST_DEVICES,
  onResponse: RECEIVE_DEVICES,
  onError: DEVICES_FAILED,
  responseKey: 'devicetypes',
  payload: {
    method: 'GET',
    url: '/devicetypes'
  }
});
